import React from "react";

export default function Definition(props) {
  return (
    <div className="definition-list">
      <p>{props.definition}</p>
    </div>
  );
}
